import React, {Component} from 'react';
import { connect }        from 'react-redux';
import { NavLink }        from 'react-router-dom';
//css
import './cookies.scss';
import x_close from 'assets/icons/x-close-mobile-icon.svg';

class Cookies extends Component {
    
    setCookie(cname, cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (365*24*60*60*1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ';' + expires +";domain=" + window.location.hostname + ";path=/;";
        this.forceUpdate();
    }
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    render() {

        let cookie = this.getCookie("hot_cookies_accepted");
        let show_msg = false;

        if (cookie !== 'true') {
            show_msg = true;
        }

        return (
            <div className="cookies_container" data-nosnippet="true">
                { show_msg &&
                    <div className="cookies_layer">
                        <p className="msg">
                            { this.props.text.web_cookies_msg }
                            <NavLink to={'/'+this.props.policyPage} className="privacy-link">
                                { this.props.text.web_cookies_privacy_link }
                            </NavLink>
                        </p>
                        <div className="accept">
                        <button style={{width: '100%', cursor: 'pointer'}}
                                onClick={ () => this.setCookie('hot_cookies_accepted', true)}
                                aria-label="קבל שימוש בעוגיות">
                            <img src={ x_close } alt="" />
                        </button>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
//get required state from redux store and map them to the components props
const mapStateToProps = store => {
    return {
        text: store.config.Translations,
        policyPage: store.config.Privacy_url,
    }
}

export default connect(mapStateToProps, null, null, { pure: false })(Cookies);